import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const UzivatelskyProfil = {
	name: NAME,
	apiProvider,
	router,
};
